import { AttachmentUploadPermissions } from '@connect-x-app/shared-domain-models';

export type SupportedMimeType = {
  extensions: string[];
  mimeType: string;
  permissions: string[];
  validFileSignatureCheck: (signature: string) => boolean;
};

export const SUPPORTED_MIME_TYPES: SupportedMimeType[] = [
  {
    extensions: ['.jpg', '.jpeg'],
    mimeType: 'image/jpeg',
    permissions: [AttachmentUploadPermissions.ALLOW_IMAGES],
    validFileSignatureCheck: (signature: string) => JPEG_SIGNATURES.some(jpegSignature => signature.startsWith(jpegSignature)),
  },
  {
    extensions: ['.png'],
    mimeType: 'image/png',
    permissions: [AttachmentUploadPermissions.ALLOW_IMAGES],
    validFileSignatureCheck: (signature: string) => PNG_SIGNATURES.some(pngSignature => signature.startsWith(pngSignature)),
  },
  {
    extensions: ['.webp'],
    mimeType: 'image/webp',
    permissions: [AttachmentUploadPermissions.ALLOW_IMAGES],
    validFileSignatureCheck: (signature: string) =>
      WEBP_SIGNATURES.some(webpSignature => {
        const [header, content] = webpSignature;
        return signature.startsWith(header) && signature.includes(content);
      }),
  },
  {
    extensions: ['.heic'],
    mimeType: 'image/heic',
    permissions: [AttachmentUploadPermissions.ALLOW_IMAGES],
    validFileSignatureCheck: (signature: string) =>
      HEIC_SIGNATURES.some(heicSignature => {
        const [header, content] = heicSignature;
        return signature.includes(header) && signature.includes(content);
      }),
  },
  {
    extensions: ['.heif'],
    mimeType: 'image/heif',
    permissions: [AttachmentUploadPermissions.ALLOW_IMAGES],
    validFileSignatureCheck: (signature: string) =>
      HEIF_SIGNATURES.some(heifSignature => {
        const [header, content] = heifSignature;
        return signature.includes(header) && signature.includes(content);
      }),
  },
  {
    extensions: ['.pdf'],
    mimeType: 'application/pdf',
    permissions: [AttachmentUploadPermissions.ALLOW_DOCUMENTS],
    validFileSignatureCheck: (signature: string) => PDF_SIGNATURES.some(pdfSignature => signature.startsWith(pdfSignature)),
  },
];

export const APPLE_ONLY_FILE_TYPES = ['.heif', '.heic'];

export const MAX_ATTACHMENT_SIZE = 12582912; // 12mb (= 12 * 1024 * 1024)

const JPEG_SIGNATURES = [
  'FFD8FF',
  'FFD8FFE0',
  'FFD8FFE1',
  'FFD8FFE2',
  'FFD8FFE3',
  'FFD8FFE8',
  'FFD8FFED',
  'FFD8FFEE',
  'FFD8FFDB',
  'FFD8FFEF',
];

const PNG_SIGNATURES = ['89504E47'];

const WEBP_SIGNATURES = [
  ['52494646', '57454250'], // Lookout, since this is also the magic number for AVI and WAV
];

const HEIC_SIGNATURES = [
  ['66747970', '68656963'],
  ['66747970', '68656978'],
];

const HEIF_SIGNATURES = [
  ['66747970', '68656966'],
  ['66747970', '6D696631'],
];

const PDF_SIGNATURES = ['255044462D'];
